import styled from 'styled-components';
import { Button } from 'antd';

export const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
`;

export const StyledButton = styled(Button)`
  &:hover {
    border: 1px solid #2c2c32 !important;
    color: black !important;
  }
`;
